import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./Logs.module.css";
import { FaSearch } from "react-icons/fa";

const backendURL = process.env.REACT_APP_API_URL8;  

const Logs = () => {
  const [logsData, setLogsData] = useState({ columns: [], rows: [] });
  const [searchTerm, setSearchTerm] = useState("");
  const [serverName, setServerName] = useState("");
  const [timestamp, setTimestamp] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 10;

  const getQueryParam = (param) => {
    return new URLSearchParams(window.location.search).get(param);
  };

  useEffect(() => {
    const serverName = getQueryParam("serverName");
    const timestamp = getQueryParam("timestamp");
    const metric = getQueryParam("metric");
    setServerName(serverName);
    setTimestamp(timestamp);

    if (serverName && timestamp) {
      axios
        .get(`${backendURL}/logs`, {
          params: { host: serverName, timestamp,metric },
        })
        .then((res) => {
        if(res.data.count === 0) {
          setLogsData({ columns: [], rows: [] });   
        } else {
          const data = res.data.data || { columns: [], rows: [] };
          setLogsData(data);
        }
        })
        .catch(() => {
          setLogsData({ columns: [], rows: [] });
        })
        .finally(() => setLoading(false));
    }
  }, []);

  // Extract unique timestamps
  const allColumns = logsData?.columns || [];
  const timestamps = [...new Set(allColumns.slice(1).map((col) => col.split("|")[0]))];
  const subHeaders = ["CPU", "Memory"];

  // Filter rows by process name
  const filteredRows = logsData?.rows?.filter((row) =>
    row["Process Name"]?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination
  const totalPages = Math.ceil(filteredRows.length / entriesPerPage);
  const paginatedRows = filteredRows.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  return (
    <div className={styles.logsPage}>
      <h2 className={styles.heading}>
        Server: <span className={styles.serverName}>{serverName}</span> | Timestamp:{" "}
        <span className={styles.timestamp}>{timestamp}</span>
      </h2>

      <div className={styles.searchWrapper}>
        <FaSearch className={styles.searchIcon} />
        <input
          type="text"
          placeholder="Search by process name..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
          className={styles.searchInput}
        />
      </div>

      {loading ? (
        <div className={styles.loading}>Loading...</div>
      ) : filteredRows.length === 0 ? (
        <div className={styles.noData}>No Data Found</div>
      ) : (
        <>
          <table className={styles.table}>
            <thead>
              <tr className={styles.tableHeader}>
                <th rowSpan={2}>Process Name</th>
                {timestamps.map((ts, idx) => (
                  <th key={idx} colSpan={2}>
                    {ts}
                  </th>
                ))}
              </tr>
              <tr className={styles.tableHeader}>
                {timestamps.map((_, idx) =>
                  subHeaders.map((label) => <th key={`${idx}-${label}`}>{label}</th>)
                )}
              </tr>
            </thead>
            <tbody>
              {paginatedRows.map((row, idx) => (
                <tr key={idx}>
                  <td>{row["Process Name"]}</td>
                  {timestamps.map((ts) =>
                    subHeaders.map((label) => {
                      const key = `${ts}|${label}`;
                      return <td key={`${row["Process Name"]}-${key}`}>{row[key] ?? "NA"}</td>;
                    })
                  )}
                </tr>
              ))}
            </tbody>
          </table>

          <div className={styles.pagination}>
            <button
              onClick={() => setCurrentPage((p) => p - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((p) => p + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Logs;
